import { useQuery } from "react-query";
import api from "../api";

export const useGetPropertyType = () => {
  return useQuery(["property_type"], () => {
    return api.get("/property/type").then((res) => res.data);
  });
};
